document.addEventListener('DOMContentLoaded', () => {

  function parsePrice(text) {
    return parseFloat(
      text.replace(/[^\d,.-]/g, '').replace(',', '.')
    );
  }

  function addPerPackPrices() {
    document.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {

      const title = bar.querySelector('.kaching-bundles__bar-title')?.textContent.trim();
      const priceEl = bar.querySelector('.kaching-bundles__bar-price');

      if (!title || !priceEl) return;

      let packCount = 0;
      let priceForCalculation = 0;

      // Buy 1 box + Wipes
      if (title.includes('Buy 1 box + Wipes')) {

        packCount = 6;

        const nappiesPriceEl = bar.querySelector(
          '.kaching-bundles__bundle-products__product:first-of-type .kaching-bundles__bundle-products__price'
        );

        if (!nappiesPriceEl) return;

        priceForCalculation = parsePrice(nappiesPriceEl.textContent);

      }
      // Buy 2 boxes
      else if (title.includes('Buy 2 boxes')) {

        packCount = 12;
        priceForCalculation = parsePrice(priceEl.textContent);

      }
      // Buy 1 box
      else if (title.includes('Buy 1 box')) {

        packCount = 6;
        priceForCalculation = parsePrice(priceEl.textContent);

      }

      if (!packCount || isNaN(priceForCalculation)) return;

      const perPackPrice = priceForCalculation / packCount;

      let existing = bar.querySelector('.custom-per-pack');

      if (!existing) {
        existing = document.createElement('div');
        existing.className = 'custom-per-pack';
        priceEl.insertAdjacentElement('afterend', existing);
      }

      existing.textContent = `€${perPackPrice.toFixed(2)} per pack`;
    });
  }

  addPerPackPrices();

  const observer = new MutationObserver(() => {
    requestAnimationFrame(addPerPackPrices);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});